<script>
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import Layout from "@/router/layouts/auth";

import appConfig from "@/app.config";

export default {
  page: {
    title: "Đăng Ký",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      user: {
        user_name: "",
        user_email: "",
        user_password: "",
        user_repassword: "",
        user_sponsor: null,
        User_Phone: "",
      },
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
    };
  },
  validations: {
    user: {
      user_name: {
        required,
      },
      user_email: {
        required,
        email,
      },
      user_password: {
        required,
        minLength: minLength(8),
      },
      user_repassword: {
        required,
        sameAsPassword: sameAs("user_password"),
      },
      User_Phone: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(12),
      },
    },
  },
  computed: {
    ...mapGetters({
      errorMessage: "core/Error",
      successMessage: "core/Success",
    }),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
    if (this.$route.query.sponsor) {
      this.user.user_sponsor = this.$route.query.sponsor;
    }
  },
  methods: {
    tryToRegisterIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.$store.dispatch("auth/req_postRegister", this.user);
      }
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      // eslint-disable-next-line default-case
      switch (mutation.type) {
        case "auth/REGISTER_SUCCESS":
          this.user = {
            user_name: "",
            user_email: "",
            user_password: "",
            user_repassword: "",
            user_sponsor: "",
            User_Phone: "",
          };
          this.$store.commit("core/SUCCESS_MESSAGE", null);
          this.$store.commit("core/ERROR_MESSAGE", null);
          break;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<template>
  <Layout>
    <div class="w-100">
      <div class="d-flex flex-column h-100">
        <div class="mb-2 mb-md-3">
          <router-link to="/" class="d-block auth-logo">
            <img src="~@/assets/images/logo/logo-light-2.png" alt="" />
          </router-link>
        </div>
        <div class="my-4">
          <div>
            <h5 class="text-white fw-bold">{{ $t("auth.register") }}</h5>
            <p class="text-white">{{ $t("auth.free-account") }}</p>
          </div>
          <!-- <div v-if="successMessage" class="alert-success alert">
            {{ successMessage }}
          </div>
          <div v-else-if="errorMessage" class="alert-danger alert">
            {{ errorMessage }}
          </div> -->
          <div class="mt-4">
            <b-form @submit.prevent="tryToRegisterIn" autocomplete="off">
              <b-form-group
                class="mb-3"
                id="username-group"
                :label="$t('auth.username')"
                label-for="username"
              >
                <b-form-input
                  id="username"
                  v-model="user.user_name"
                  type="text"
                  :placeholder="$t('auth.enter-username')"
                  :class="{
                    'is-invalid': submitted && $v.user.user_name.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.user_name.required"
                  class="invalid-feedback"
                >
                  {{ $t("auth.required-user") }}
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="email-group"
                :label="$t('auth.email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="user.user_email"
                  type="email"
                  :placeholder="$t('auth.enter-email')"
                  :class="{
                    'is-invalid': submitted && $v.user.user_email.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.user.user_email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.user.user_email.required">
                    {{ $t("auth.required-email") }}
                  </span>
                  <span v-if="!$v.user.user_email.email">
                    {{ $t("auth.enter-email2") }}
                  </span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="password-group"
                :label="$t('auth.password')"
                label-for="password"
              >
                <b-form-input
                  id="password"
                  v-model="user.user_password"
                  type="password"
                  :placeholder="$t('auth.enter-password')"
                  :class="{
                    'is-invalid': submitted && $v.user.user_password.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.user.user_password.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.user.user_password.required">
                    {{ $t("auth.required-password") }}
                  </span>
                  <span v-if="!$v.user.user_password.minLength">
                    {{ $t("auth.min-length") }}
                  </span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="repass-group"
                :label="$t('auth.re-password')"
                label-for="repass"
              >
                <b-form-input
                  id="repass"
                  v-model="user.user_repassword"
                  type="password"
                  :placeholder="$t('auth.re-password')"
                  :class="{
                    'is-invalid': submitted && $v.user.user_repassword.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.user_repassword.required"
                  class="invalid-feedback"
                >
                  {{ $t("auth.required-re-password") }}
                </div>
                <div
                  v-if="submitted && !$v.user.user_repassword.sameAsPassword"
                  class="invalid-feedback"
                >
                  {{ $t("auth.sameAsPassword") }}
                </div>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="username-group"
                :label="$t('auth.phone')"
                label-for="username"
              >
                <b-form-input
                  id="username"
                  v-model="user.User_Phone"
                  type="text"
                  :placeholder="$t('auth.enter-phone')"
                  :class="{
                    'is-invalid': submitted && $v.user.User_Phone.$error,
                  }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.user.User_Phone.required"
                  class="invalid-feedback"
                >
                  {{ $t("auth.required-phone") }}
                </div>
                <div
                  v-if="submitted && !$v.user.User_Phone.minLength"
                  class="invalid-feedback"
                >
                  {{ $t("auth.min-phone") }}
                </div>
                <div
                  v-if="submitted && !$v.user.User_Phone.maxLength"
                  class="invalid-feedback"
                >
                  {{ $t("auth.max-phone") }}
                </div>
              </b-form-group>
              <b-form-group
                class="mb-3"
                id="sponsor-group"
                :label="$t('auth.sponsor')"
                label-for="sponsor"
              >
                <b-form-input
                  id="sponsor"
                  v-model="user.user_sponsor"
                  type="text"
                  :placeholder="$t('auth.enter-sponsor')"
                ></b-form-input>
              </b-form-group>
              <div class="mt-4 d-grid">
                <b-button type="submit" variant="primary" class="btn-block">
                  {{ $t("auth.register") }}
                </b-button>
              </div>
            </b-form>

            <div class="mt-5 text-center">
              <p>
                {{ $t("auth.has-account") }}
                <router-link :to="{ name: 'login' }" class="fw-bold text-white">
                  {{ $t("auth.login") }}
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
::v-deep .carousel-caption {
  position: relative !important;
  right: 0;
  left: 0;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
}

::v-deep .carousel-indicators li {
  background-color: rgba(85, 110, 230, 0.25);
}
</style>
